"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ConceptMap_Group = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_ConceptMap_Element_1 = require("./RTTI_ConceptMap_Element");
var RTTI_ConceptMap_Unmapped_1 = require("./RTTI_ConceptMap_Unmapped");
exports.RTTI_ConceptMap_Group = t.recursion('IConceptMap_Group', function () {
    return t.intersection([
        t.type({
            element: t.array(RTTI_ConceptMap_Element_1.RTTI_ConceptMap_Element)
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            source: RTTI_uri_1.RTTI_uri,
            _source: RTTI_Element_1.RTTI_Element,
            sourceVersion: t.string,
            _sourceVersion: RTTI_Element_1.RTTI_Element,
            target: RTTI_uri_1.RTTI_uri,
            _target: RTTI_Element_1.RTTI_Element,
            targetVersion: t.string,
            _targetVersion: RTTI_Element_1.RTTI_Element,
            unmapped: RTTI_ConceptMap_Unmapped_1.RTTI_ConceptMap_Unmapped
        })
    ]);
});
//# sourceMappingURL=RTTI_ConceptMap_Group.js.map